export const esPersonaNatural = (datos) => datos?.tipoPersona === "Persona Natural";

export const identificacionSubarrendatario = ({
	nombre,
	rut,
	razon,
	rutEmpresa,
	nacionalidad,
	tipoPersona,
}) =>
	tipoPersona === "Persona Natural"
		? `${nombre}, Rut ${rut}, de nacionalidad ${nacionalidad}`
		: `${nombre}, Rut ${rut}, Representante legal de la empresa ${razon}, Rut número ${rutEmpresa}, de nacionalidad ${nacionalidad}`;

export const nombreParaArchivo = ({ nombre, razon, tipoPersona }) =>
	tipoPersona === "Persona Natural" ? nombre : razon;

export const firmaSubarrendatario = (doc, datos, yLinea) => {
	const { nombre, rut, razon, rutEmpresa } = datos;
	doc.line(10, yLinea, 90, yLinea);
	if (esPersonaNatural(datos)) {
		doc.text(`${nombre}`, 10, yLinea + 5);
		doc.text(`${rut}`, 10, yLinea + 10);
		return;
	}
	doc.text(`${razon}`, 10, yLinea + 5);
	doc.text(`${rutEmpresa}`, 10, yLinea + 10);
	doc.text(`P.p. ${nombre}`, 10, yLinea + 15);
	doc.text(`${rut}`, 10, yLinea + 20);
};
